export const INPUT_CLASS_NAME = 'condition-value-input';
